import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { InsuranceVerification, InsuranceVerificationSource } from '@/types/insuranceVerification';
import ajax from '@/utils/ajax';

export const insuranceVerificationRepository = {
  BASE_PATH: '/api/dugout/insurance_verifications/',

  async createInsuranceVerification({
    host,
    values
  }: {
    host: string;
    values: Partial<InsuranceVerification>;
  }): Promise<InsuranceVerification> {
    const response = await ajax.post<
      Partial<InsuranceVerification>,
      AxiosResponse<InsuranceVerification>
    >({
      url: `${host}${this.BASE_PATH}`,
      data: values
    });

    return response.data;
  },

  async getVerificationSources({ host }: { host: string }): Promise<InsuranceVerificationSource[]> {
    const response = await ajax.get({ url: `${host}${this.BASE_PATH}list_verification_sources/` });

    return response.data;
  },

  async getVerificationStatuses({ host }: { host: string }): Promise<string[]> {
    const response = await ajax.get({ url: `${host}${this.BASE_PATH}list_verification_statuses/` });

    return response.data;
  }
};

const InsuranceVerificationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async createInsuranceVerification(
      values: Partial<InsuranceVerification>
    ): Promise<InsuranceVerification> {
      return insuranceVerificationRepository.createInsuranceVerification({
        host,
        values
      });
    },

    async getVerificationSources(): Promise<InsuranceVerificationSource[]> {
      return insuranceVerificationRepository.getVerificationSources({ host });
    },

    async getVerificationStatuses(): Promise<string[]> {
      return insuranceVerificationRepository.getVerificationStatuses({ host });
    }
  };
};

export default InsuranceVerificationRepository;
